// ==============================
// 파일명 : src/utils/math.js
// 역할 : 숫자 계산과 보정이 필요한 컴포넌트에서
//         재사용할 수 있는 수학 관련 유틸 모음
// 수정일 : 2025-10-12
// ==============================

export const clampValue = (value, min, max) =>
  Math.min(Math.max(value, min), max); // [수정] 주어진 범위로 값 고정